module.exports = __webpack_public_path__ + "media/images/features/5/history-2-9ac2555a1fbfae1fb39ccaa80acebdc4.jpg";